import { Text } from "@dropbox/dig-components/typography";
import { BoxEmptySpot } from "@dropbox/dig-illustrations";
import classnames from "classnames";
import styles from "./EmptyStateCard.module.css";

export const EmptyStateCard = ({ message }: { message: string }) => {
  return (
    <div className={classnames(styles.container)}>
      <div className={styles.assetContainer}>
        <div className={styles.iconContainer}>
          <BoxEmptySpot />
        </div>
      </div>
      <div className={styles.textContentContainer}>
        <div>
          <Text className={styles.message} size="medium" tagName="p">
            {message}
          </Text>
        </div>
      </div>
    </div>
  );
};
